import { uniq } from 'lodash';

import {
  formatToolDisplayName,
  isFreestyleGenerationTool,
  isMultiPromptTool,
} from 'src/data/generationTool';

export const generateToolListTooltip = (toolList) => {
  const displayNames = toolList.map((tool) =>
    // A general-prompt block writes plain text — "prompt" names what the user gives it, not what it
    // produces, which is what this list is about.
    isFreestyleGenerationTool(tool)
      ? 'General text'
      : formatToolDisplayName(tool, { useTitle: true })
  );
  const uniqueNames = uniq(displayNames);
  return uniqueNames.join('\n');
};

/**
 * The tools the row of icons stands for. A template's general-prompt block says nothing about what
 * that template writes, so it is left out of the icons while staying in the list on hover. A card
 * for a single tool keeps its own icon whatever the tool is — there the icon is the card's identity
 * rather than a summary of sections.
 */
export const getCardIconTools = (generationTool, toolList) =>
  isMultiPromptTool(generationTool)
    ? toolList.filter((tool) => !isFreestyleGenerationTool(tool))
    : toolList;
